import { useDispatch, useSelector } from 'react-redux';
import './FundingLayout.scss';
import MobileStepper from '../MobileStepper/MobileStepper';
import { SSJBeaconButton } from '../Beacon/Registry';

import { decrementStep } from '../../../redux/modules/transferFunding/stepActions';
import config from '../../../config/config';
import backArrow from '../../../assets/images/back.svg';
import '../Faq/Faq.scss';

export const navigateBack = (currStep, dispatchFunction) => {
  if (currStep === 0) {
    window.location.href = `${config.url}/usis/my-accounts/dashboard`;
  } else {
    dispatchFunction(decrementStep());
  }
};

export const FundingLayout = ({
  listSteps,
  leftSection,
  wizard,
  faqSection,
  summary,
}) => {
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state?.currentStep?.initialState);

  return (
    <div id="funding-layout">
      <div className="container container_main-section_wrapper">
        <div className="container_left-section col-sm-12  col-md-7">
          {listSteps[currentStep]?.showWizard && (
            <MobileStepper listSteps={listSteps} />
          )}
          {listSteps[currentStep]?.showBackLink && (
            <div className="container_left-section_back-btn">
              <img src={backArrow} alt="Back Arrow" className="back-arrow" />
              <SSJBeaconButton
                id="backButton"
                scale="jumbo"
                label="Back"
                iconAlign="left"
                variant="tertiary"
                onClick={() => {
                  navigateBack(currentStep, dispatch);
                }}
              />
            </div>
          )}
          <div className="container_left-section_detail">{leftSection}</div>
        </div>
        <div className="col-md-1" />
        <div className="container_right-section col-md-4 step-faq">
          <div className="container_right-section-wizard">{wizard}</div>
          <div className="container_right-section-faq">{faqSection}</div>
          <div className="container_right-section-faq">{summary}</div>
        </div>
      </div>
    </div>
  );
};
